import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from './Analytics.ts';
export function sendRushInitialPlacementTimeoutAnalytic(gameId, analyticFormat) {
    void CA.sendAnalyticEventsWithMobileDimensions({
        type: AnalyticEventType.RushInitialPlacementTimedOut,
        category: AnalyticEventCategory.Game,
        dimensions: {
            gameId: gameId,
            placementRound: analyticFormat.placementRound,
            timeoutOutcome: analyticFormat.timeoutOutcome
        }
    });
}
